import { Locale } from "antd/es/locale";
import enUS from "antd/es/locale/en_US";
import esES from "antd/es/locale/es_ES";
import frFR from "antd/es/locale/fr_FR";
import ruRU from "antd/es/locale/ru_RU";
import zhCN from "antd/es/locale/zh_CN";

export const DEFAULT_LANGUAGE = "en";
export const I18NEXT_LANGUAGE_STORAGE_KEY = "i18nextLng";
export const EXPLICIT_LANGUAGE_STORAGE_KEY = "cornix_explicit_language";

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "ru", label: "Русский" },
  { value: "fr", label: "Français" },
  { value: "zh", label: "简体中文" },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map(
  (option) => option.value
);

const LANGUAGE_TO_ANTD_LOCALE: Record<string, Locale> = {
  en: enUS,
  es: esES,
  fr: frFR,
  ru: ruRU,
  zh: zhCN,
};

export const getAntdLocale = (language: string) =>
  LANGUAGE_TO_ANTD_LOCALE[language] ?? enUS;

export const isSupportedLanguage = (language?: string | null) =>
  !!language && LANGUAGE_OPTIONS.some((option) => option.value === language);

const getStorageItem = (key: string) => {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

const setStorageItem = (key: string, value: string) => {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    // Storage access can be denied during bootstrap; ignore and continue.
  }
};

export const setExplicitLanguageSelection = () => {
  setStorageItem(EXPLICIT_LANGUAGE_STORAGE_KEY, "true");
};

export const hasExplicitLanguageSelection = () => {
  return getStorageItem(EXPLICIT_LANGUAGE_STORAGE_KEY) === "true";
};
